export enum CONTENT_TYPES {
    /**
     * @todo migrate key from legacy project and change id.
     * @value Content types
     */
    CONTENT_TYPES = 'SEARCH_PLUS_CONTENT_TYPES',
    /**
     * @value Choose a content type first to filter by tags
     * @description Helper text for the content type tag filter.
     */
    CONTENT_TYPES_TAGS_FILTER_HELPER = 'CONTENT_TYPES.CONTENT_TYPES_TAGS_FILTER_HELPER',
    /**
     * @value Content type deleted successfully
     */
    CONTENT_TYPE_DELETE_SUCCESS = 'ADMIN_CUSTOM_CONTENT_TYPE_DELETE_SUCCESS',
    /**
     * @value Content type saved successfully
     */
    CONTENT_TYPE_SAVE_SUCCESS = 'ADMIN_CUSTOM_CONTENT_TYPE_SAVE_SUCCESS',
    /**
     * @value Tag deleted successfully
     */
    CONTENT_TYPE_TAG_DELETE_SUCCESS = 'ADMIN_CUSTOM_CONTENT_TYPE_TAG_DELETE_SUCCESS',
    /**
     * @value No tag configured with this content type
     */
    CONTENT_TYPE_TAG_NO_RESULT_FOR_CONTENT_TYPES = 'WIDGET_TYPE_CONTENT-TAGS_TAGS_MISSING',
    /**
     * @value Create without a template
     */
    CREATE_FROM_SCRATCH = 'ADMIN.CONTENTS.CREATE_FROM_SCRATCH',
    /**
     * @value Delete a content type
     */
    DELETE = 'ADMIN_CUSTOM_CONTENT_TYPE_DELETE',
    /**
     * @value Are you sure you want to delete this content type?
     */
    DELETE_DESCRIPTION = 'ADMIN_CUSTOM_CONTENT_TYPE_DELETE_DESCRIPTION',
    /**
     * @value Enable publication workflow
     */
    ENABLE_WORKFLOW = 'ADMIN_CUSTOM_CONTENT_TYPE_ENABLE_WORKFLOW',
    /**
     * @value Require validation before publishing a content.
     */
    ENABLE_WORKFLOW_HELP = 'ADMIN_CUSTOM_CONTENT_TYPE_ENABLE_WORKFLOW_HELP',
    /**
     * @value Maximum publication period (months)
     */
    END_DATE_DELTA = 'ADMIN_CUSTOM_CONTENT_TYPE_END_DATE_DELTA',
    /**
     * @value Heritable
     */
    HERITABLE = 'ADMIN_CUSTOM_CONTENT_TYPE_HERITABLE',
    /**
     * @value The content type will be accessible by site children.
     */
    HERITABLE_HELP = 'ADMIN_CUSTOM_CONTENT_TYPE_HERITABLE_HELP',
    /**
     * @value The content type will be accessible by children sites. The process may take a few minutes.
     * @description In veolia back to standard context, the content type Page & News are now heritable. But the process may take few minutes to apply the heritable context in children sites. During the process, the checkbox is disabled.
     */
    HERITABLE_LOCK_HELP = 'ADMIN.CUSTOM_CONTENT_TYPE_HERITABLE_LOCK_HELP',
    /**
     * @value Lists
     */
    LISTS = 'ADMIN.NAV.CUSTOM_CONTENT_TYPE_LISTS',
    /**
     * @value Always create content from a template
     */
    LOCK_CREATE_CONTENT_FROM_SCRATCH = 'ADMIN.CUSTOM_CONTENT_TYPES.LOCK_CREATE_CONTENT_FROM_SCRATCH',
    /**
     * @value Content must be created from a template. Administrators still create content from scratch.
     */
    LOCK_CREATE_CONTENT_FROM_SCRATCH_HELP = 'ADMIN_CUSTOM_CONTENT_TYPE_LOCK_CREATE_CONTENT_FROM_SCRATCH_HELP',
    /**
     * @value End date mandatory
     */
    MANDATORY_END_DATE = 'ADMIN_CUSTOM_CONTENT_TYPE_MANDATORY_END_DATE',
    /**
     * @value An end date must be set on the content before saving it.
     */
    MANDATORY_END_DATE_HELP = 'ADMIN_CUSTOM_CONTENT_TYPE_MANDATORY_END_DATE_HELP',
    /**
     * @value Notify Contributors
     */
    NOTIFY = 'ADMIN_CUSTOM_CONTENT_TYPE_NOTIFY',
    /**
     * @value Notification will be sent 60, 30, 15, 7 and 3 days before the end of the publication.
     */
    NOTIFY_HELP = 'ADMIN_CUSTOM_CONTENT_TYPE_NOTIFY_HELP',
    /**
     * @value Content types management
     */
    SETTINGS = 'ADMIN_CUSTOM_CONTENT_TYPE_SETTINGS',
    /**
     * @value Templates
     */
    TEMPLATES = 'ADMIN.NAV.CUSTOM_CONTENT_TYPE_TEMPLATES',
    /**
     * @value Content types
     */
    TYPES = 'CONTENT_TYPES',
}
